/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Events_BodyInputs */

const en_features_events_body = /** @type {(inputs: Features_Events_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mobility on Saturday, a workshop on Sunday. You set the seats, clients sign up and pay on their own, and you see how many are left.`)
};

const pl_features_events_body = /** @type {(inputs: Features_Events_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mobility w sobotę, warsztat w niedzielę. Ustalasz liczbę miejsc, klienci zapisują się i płacą sami, a Ty widzisz, ile zostało.`)
};

/**
* | output |
* | --- |
* | "Mobility on Saturday, a workshop on Sunday. You set the seats, clients sign up and pay on their own, and you see how many are left." |
*
* @param {Features_Events_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_events_body = /** @type {((inputs?: Features_Events_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Events_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_events_body(inputs)
	return en_features_events_body(inputs)
});